<div class="cell cell--top">
</div>
<div class="cell cell--bottom">
    {{params?.valueFormatted}}
</div>